import React, { useState, useEffect, useContext, Fragment } from 'react';
import { LoginContext } from '../../../hooks/context/LoginContext';
import imageCompression from "browser-image-compression";
import axios from 'axios';
import Cookies from 'universal-cookie';
import Section from '../../ui/Section';
import swal from 'sweetalert';
import Modal from 'react-bootstrap/Modal';
import FormInput from '../FormInput';
import Button from '../../ui/Button';
import MiSelect from '../MiSelect';
import MiDataTableGesUplm from './MiDataTableGesUplm';
import MiDataTableGesUplmPendingList from './MiDataTableGesUplmPendingList';
import { Spinner } from 'react-bootstrap';
import { alertService } from '../../../services/alertservice';
import { MiReplaceAll, getApiUrl, axiosPost, encryptData, getDecodedCookie } from '../../../helpers/helperApp';
import FormRow from '../FormRow';
import MiDataTableGesUplmRenovar from './MiDataTableGesUplmRenovar';

function GesUplm(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source(); 
    const source2 = CancelToken.source(); 

    const { apiKey, appCryptCom } = useContext(LoginContext);
    
    const [ loading, saveLoading ] = useState(false);
    const [ infoTipAdj, saveInfoTipAdj ] = useState("");
    const [ adjuntos, saveAdjuntos ] = useState([]);
    const [ adjuntosExistentes, saveAdjuntosExistentes ] = useState([]);
    const [ idGes, saveIdGes] = useState(0);      
    const [ optionSelect, saveOptionsSelect ] = useState(null);
    const [ validacionesUplm, saveValidacionesUplm ] = useState([]);
    const [ adjuntosRenovar, saveAdjuntosRenovar ] = useState([]);
    const [ rowData, saveRowData ] = useState(null);
    const [ showModalHistoria, saveShowModalHistoria ] = useState(false);
    const [ datosHistoria, saveDatosHistoria ] = useState([]);
    const [showModalUrl, saveShowModalUrl] = useState(false);
    const [url, saveUrl] = useState("");
    const [urlVacia, saveUrlVacia] = useState(false);
    const [accionModalUrl, saveAccionModalUrl] = useState("");
    const [rowAdj, saveRowAdj] = useState();
    const [errorConfig, saveErrorConfig] = useState("");    

    const { confPantalla, idTipAdj, bbdd } = props;

    useEffect( () => {          
        if(idTipAdj != null){
            inicio();
        }              
    },[idTipAdj])

    const inicio =  async() => {
            await getValidacionesGesDoc();
            const info = await init(); 
            if(info != null){
                getDataCbo(confPantalla.gesdoc.controles.gesuplm.select.datatype, confPantalla.gesdoc.controles.gesuplm.select.data, info.idstipadj);
            }           
    }

    const init = async (btnDataTable=false, idSelectGes=null) => {
        
        saveLoading(true);

        const data = new FormData();
         if(btnDataTable == true){                                        
            let btn = document.getElementsByClassName('filterBtnGesDoc');
            if(btn && btn[0] && btn[0].classList.contains('active')) {
                btn[0].classList.remove('active');
            } else if(btn && btn[0].classList) {
                btn[0].classList.add('active');
                data.append("mostrarArchivados", true);
            }            
        }else{
            let btn = document.getElementsByClassName('filterBtnGesDoc');
            if(btn && btn[0] && btn[0].classList.contains('active')) {                
                data.append("mostrarArchivados", true);
            }
        }
        data.append("validacion", apiKey());
        data.append("idtipadj", idTipAdj);
        if(idSelectGes != null){
            data.append("idselectges", idSelectGes);
        }else{
            const selectGes = document.querySelectorAll('input[name*="selectges"]'); 
            if(selectGes[0] &&  selectGes[0].value != ""){
                idSelectGes = selectGes[0].value;
                data.append("idselectges", selectGes[0].value);
            }  
        }                
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+'/gesdoc/GetDocumentacion', data, source.token);

        if(respuesta.data.error != ""){
            // Mostrar error 
            saveLoading(false);
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true});
            return;
        }        
        if(respuesta.data.infotipadj.length == 0){
            // Error no existe ese tipo de adjunto
            saveErrorConfig(confPantalla.config.trad.components.gesuplm.errorconfig.error1.title);
            saveLoading(false);
            return null;
        }else if(respuesta.data.infotipadj[0].idges == "0"){
            // Error no está configurado ese tipo de adjunto
            saveErrorConfig(confPantalla.config.trad.components.gesuplm.errorconfig.error2.title);
            saveLoading(false);
            return null;
        }else{
            saveInfoTipAdj(respuesta.data.infotipadj[0]);
            saveAdjuntosExistentes(respuesta.data.docs);
            saveLoading(false);
            return respuesta.data;
        }
    }

    const guardar = async () => {        
        saveLoading(true);

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idreg", idGes);
        data.append("idges", infoTipAdj.idges);
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        const tablasRelGestiones = ["", "rel_agentes_adj", "rel_unidades_adj", "rel_centros_adj", "rel_documentos_adj", "rel_equipos_adj"];
        for(let i = 0; i < adjuntos.length; i++ ){            
            if( !adjuntos[i].urlAdd ){
                data.append(tablasRelGestiones[infoTipAdj.idges]+"[]", adjuntos[i]);
            }
        }        
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/gesdoc/saveDocumentacion',data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if( respuesta.data.error != "" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true});
            saveLoading(false);
            return;
        }    
        
        saveAdjuntos([]);
        await init();
        saveLoading(false);
        alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.config.trad.components.gesuplm.guardarok.title}`, {autoClose: true});
    }

    // ***** Leer los archivos del input *****
    const handleFiles = async files => {
        
        let validaciones;
        if(validacionesUplm.length == 0){
            validaciones = await getValidacionesGesDoc(true);
        }else{
            validaciones = validacionesUplm;
        }

        let extensiones = validaciones[0]["val"].split("|");
        let maxWidth = parseInt(validaciones[1]["val"].split("x")[0]);
        let maxSize = validaciones[2]["val"];
        const optionsCompres = {          
            maxSizeMB: validaciones[2]["val"],
            maxWidthOrHeight: maxWidth,
            useWebWorker: false
        }        
        
        for(let i = 0; i < files.length; i++){
            
            const duplicado = adjuntos.filter( adj =>  adj.name === files[i].name );

            if(duplicado.length === 0){
                let valido = true;
                //Validamos la extensión
                if( !validateExtension(files[i], extensiones) ){
                    swal("Error", `${files[i]["name"]} ${confPantalla.config.trad.components.uplm.errorextension.title}`, "error");
                    valido = false;
                }
    
                if( files[i]["type"].split("/")[0] === "image" ){
                    //Imágenes 
                        if( valido ){
                            //Hacemos el resize para las imágenes                    
                            let fileResize = await imageCompression(files[i], optionsCompres); 
                            let aux = await blobToFile(fileResize, files[i]);
                            //Actualizamos el state
                            saveAdjuntos( adjuntos => [...adjuntos, aux] );                            
                        }               
                }else{
                    //Resto de arhivos
                    if( !validateSize(files[i], validaciones) ){                   
                        swal("Error", `${files[i]["name"]} ${confPantalla.config.trad.components.uplm.errorsize.title} (${maxSize}Mb)`, "error");
                    }else{
                        //Actualizamos el state
                        if(valido){ 
                            saveAdjuntos( adjuntos => [...adjuntos, files[i]] )                              
                        } 
                    }
                }
            }else{
                swal("Error", `${duplicado[0]["name"]} ${confPantalla.config.trad.components.uplm.duplicate.title}`, "error");
            }

        }
        //Borramos el value del input file multiple para manejarlos a nuestro antojo en la función que crea el FormData y envía el formulario
        document.querySelector('#inputFiles').value = "";
    }

    const renovar = async (files, rowAdj, tabla) => {
        saveAdjuntosRenovar([]);           
        // files = files.target.files;
       let validaciones;       
        if(validacionesUplm.length == 0){
            validaciones = await getValidacionesGesDoc(true);
        }else{
            validaciones = validacionesUplm;
        }

        let extensiones = validaciones[0]["val"].split("|");
        let maxWidth = parseInt(validaciones[1]["val"].split("x")[0]);
        let maxSize = validaciones[2]["val"];
        const optionsCompres = {          
            maxSizeMB: validaciones[2]["val"],
            maxWidthOrHeight: maxWidth,
            useWebWorker: false
        }            

        for(let i = 0; i < files.length; i++){
            
            const duplicado = adjuntosRenovar.filter( adj =>  adj.name === files[i].name );

            if(duplicado.length === 0){
                let valido = true;
                //Validamos la extensión
                if( !validateExtension(files[i], extensiones) ){
                    swal("Error", `${files[i]["name"]} ${confPantalla.config.trad.components.uplm.errorextension.title}`, "error");
                    valido = false;
                }
    
                if( files[i]["type"].split("/")[0] === "image" ){
                    //Imágenes 
                        if( valido ){
                            //Hacemos el resize para las imágenes                    
                            let fileResize = await imageCompression(files[i], optionsCompres); 
                            let aux = await blobToFile(fileResize, files[i]);
                            //Actualizamos el state                                                
                            setTimeout(() => {
                                if(tabla == 'tablaHistoriaAdjs'){
                                    saveShowModalHistoria(false);
                                }
                                saveAdjuntosRenovar(() => [aux]);
                            }, 0);                           
                        }               
                }else{
                    //Resto de arhivos
                    if( !validateSize(files[i], validaciones) ){                   
                        swal("Error", `${files[i]["name"]} ${confPantalla.config.trad.components.uplm.errorsize.title} (${maxSize}Mb)`, "error");
                    }else{
                        //Actualizamos el state
                        if(valido){                               
                            const aux = new File([files[i]], files[i].name, { type: files[i].type });                          
                            setTimeout(() => {
                                if(tabla == 'tablaHistoriaAdjs'){
                                    saveShowModalHistoria(false);
                                }
                                saveAdjuntosRenovar(() => [aux]);
                            }, 0);                              
                        } 
                    }
                }
            }else{
                swal("Error", `${duplicado[0]["name"]} ${confPantalla.config.trad.components.uplm.duplicate.title}`, "error");
            }

        }
        saveRowData(rowAdj); 
        //Borramos el value del input file multiple para manejarlos a nuestro antojo en la función que crea el FormData y envía el formulario
        document.querySelector('#inputFilesrenovar').value = "";
    }

    const renovarAction = async() => {              

        saveLoading(true);

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("rowData", JSON.stringify(rowData));
        data.append("idges", infoTipAdj.idges);
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileReNew**"], textarea[name*="fileReNew**"], input[name*="fileReNewUrl**"], textarea[name*="fileReNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){           
            data.append(inputsNews[i].name.replace("fileReNew", "fileNew"), inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        const tablasRelGestiones = ["", "rel_agentes_adj", "rel_unidades_adj", "rel_centros_adj", "rel_documentos_adj", "rel_equipos_adj"];
        for(let i = 0; i < adjuntosRenovar.length; i++ ){            
            if( !adjuntosRenovar[i].urlAdd ){
                data.append(tablasRelGestiones[infoTipAdj.idges]+"[]", adjuntosRenovar[i]);
            }
        }        
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/gesdoc/renovar',data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if( respuesta.data.error != "" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true});
            saveLoading(false);
            return;
        }    
        
        saveAdjuntosRenovar([]);
        await init();
        saveLoading(false);
        alertService.success(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.config.trad.components.gesuplm.renovarok.title}`, {autoClose: true});

    }

    const verHistoria = async (e, rowData, tabla) => {

        saveLoading(true);

        const data = new FormData();         
        data.append("validacion", apiKey());
        data.append("idadj", rowData.id);        
        data.append("idtipadj", idTipAdj);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+'/gesdoc/gethistoria', data, source.token);
        
        if(respuesta.data.error != ""){
            // Mostrar error 
            saveLoading(false);
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true});
            return;
        }
        
        saveLoading(false);

        saveDatosHistoria(respuesta.data.data);

        saveShowModalHistoria(true);        
    }

    // Funciones para los enlaces
    const addUrl = e => {
        saveAccionModalUrl("crear");        
        saveUrl("");
        saveUrlVacia("");
        saveShowModalUrl(true)
    }

    const handleUrl = e => {
        const { name, value } = e.target;
        saveUrl(value)    
    }

    const addUrlAction = e => {
        if( url != "" ){
            const regex = /^(?:(?:https?|ftp):\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?::\d+)?(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/;
            if(regex.test(url)){
                let aux = { name: url, urlAdd: url, idtip: "", fecha: "" }  
                if(accionModalUrl == "renovar"){
                    saveAdjuntosRenovar([]);                                                          
                    setTimeout(() => {
                        saveUrlVacia(false);
                        saveShowModalUrl(false);
                        saveShowModalHistoria(false);
                        saveAdjuntosRenovar(() => [aux]);
                    }, 0);                
                }else{
                    // Comprobamos que esa url no esté pendiente de subir                                          
                    let existe = adjuntos.filter(adj => adj.name == url);                
                    if( existe.length > 0 ){
                        saveUrlVacia("existe");
                    }else{
                        saveUrlVacia(false);
                        saveShowModalUrl(false);
                        saveAdjuntos( adjuntos => [...adjuntos, aux] ) 
                    }
                }            
            }else{
                // url inválida
                saveUrlVacia("invalida");
            }           
        }else{
            saveUrlVacia(true);
        }
        saveRowData(rowAdj); 
        //Borramos el value del input file multiple para manejarlos a nuestro antojo en la función que crea el FormData y envía el formulario
        document.querySelector('#inputFilesrenovar').value = "";
    }

    const renovarUrl = (files, rowAdj, tabla) => {       
        saveAccionModalUrl("renovar"); 
        saveRowAdj(rowAdj);
        saveUrl("");
        saveUrlVacia("");
        saveShowModalUrl(true)          
    }

    const validateExtension = (file, extensiones) => {
        let fileExtension = file["name"].split(".")[file["name"].split(".").length-1];
        const valido = extensiones.find(ext => fileExtension.toLowerCase() == ext.toLowerCase());
        return valido;
    }

    const validateSize = (file, validaciones) => {
        let valido = true;
        let maxSize = validaciones[2]["val"];

        if( (file["size"] / 1000) > (maxSize * 1000) ){
            valido = false;
        }

        return valido;
    }

    const blobToFile = (blob, file) => {
        blob.lastModifiedDate = file.lastModifiedDate;
        blob.name = file.name;
        return new File([blob], file.name,{type: "image/jpeg", lastModified: file.lastModifiedDate });     
    }

    const handleSelectGes = async (selectedItem, nameOfComponent) => {
        if( selectedItem ){
            await init(false, selectedItem.value);
            saveIdGes(selectedItem.value);
        }else{
            await init(false, 0);  
            saveIdGes(0);
        }
    }

    const getDataCbo = async(fuente, opcion, idsTipAdj) => {
        if( fuente === "codigo" ){
            if( typeof opcion === "string" ){
                if( opcion.includes("´") ){
                    const search = '´';
                    const replaceWith = '"';
                    opcion = opcion.split(search).join(replaceWith);
                }
                opcion = JSON.parse(opcion);
            }
            saveOptionsSelect(opcion); 
        }else{
            const data = new FormData();
            data.append("validacion", apiKey());            
            
            if( bbdd ){
                bbdd = await encryptData(bbdd, appCryptCom);
                data.append('bd', bbdd);
            }
            const idCookie = await encryptData(cookies.get('id'), appCryptCom);
            data.append('ua', idCookie);
            const nivelCookie = await encryptData(cookies.get('nivel'), appCryptCom);
            data.append('na', nivelCookie);
            const like = await encryptData(` WHERE tip_adj.id IN(${idsTipAdj}) `, appCryptCom);
            data.append('like', like)
                        
            // Encriptamos el tag sql. 
            opcion = await encryptData(opcion, appCryptCom);
            data.append(fuente, opcion);

            let url = null;
            if( fuente == "filter" ){
                url = getApiUrl(window.location.origin)+'/filters/getFilter';
            }else{
                url = getApiUrl(window.location.origin)+'/app/getDataCbo';
            }

            // const respuesta = await axios.post(url, data);
            const respuesta = await axiosPost(url, data, source2.token);
            saveOptionsSelect(respuesta.data);
        }
    }

    const getValidacionesGesDoc = async (returnData = false) => {  
        let datos = null;          
        if( validacionesUplm.length === 0 ){            
            const data = new FormData(); 
            const validacion = apiKey();
            data.append("validacion", validacion);
            const getValidacionesUplm = async () => {
                let validaciones = null;
                const response = await axios.post(getApiUrl(window.location.origin)+"/adj/getValidaciones", data)
                if( typeof response.data !== "string" ){
                    saveValidacionesUplm(response.data);
                    validaciones = response.data;
                }else{
                    swal("Error", `${confPantalla.config.trad.components.uplm.loadvalidationserror.title}`, "error");
                } 
                return validaciones;               
            }
            
            datos = await getValidacionesUplm();            
        }else{
            datos = validacionesUplm;
        }        
        if(returnData){
            return datos;
        }
    }

    return(
        <Fragment>
            {
                errorConfig != ""
                ?
                    <div className="container-fluid">
                        <div className="alert alert-danger text-center" role="alert">
                            {errorConfig}
                        </div>                
                    </div>
                :
                    <Section
                        tituloenhtml={true} 
                        titulo={ infoTipAdj.nombre } 
                        icono={ confPantalla.gesdoc.section.icono } 
                        col={ confPantalla.gesdoc.section.col } 
                        informes={confPantalla.gesdoc.controles.informes}
                        informesFilter={idTipAdj}                                
                    >
                        {/* "data" : [
                            { "value" : "1", "label" : "Agentes"}, 
                            { "value" : "2", "label" : "Articulos"},
                            { "value" : "3", "label" : "Centros"},
                            { "value" : "4", "label" : "Operaciones"},
                            { "value" : "5", "label" : "Equipos"}
                        ], */}
                        <MiDataTableGesUplmPendingList
                            id={'pendingtable'} 
                            adjuntos={ adjuntos }
                            saveAdjuntos= { saveAdjuntos }                    
                            readonly={""}
                            estadoForm={""}
                            traduction={confPantalla.config.trad.components}
                            optionSelect={ optionSelect }
                            datatable={ confPantalla.gesdoc.controles.gesuplm.datatablepending }
                        />
                        {
                            adjuntos.length > 0
                            ?                        
                                <Button 
                                    clases={ "btn-block mb-4" }
                                    color={ "success" }  
                                    type="button" 
                                    icono={ "" }   
                                    id=""     
                                    texto={confPantalla.config.trad.components.gesuplm.btnguardar.title}   
                                    accion={ () => guardar() } 
                                    disabled={ loading ? true : false }
                                />                        
                            :
                                null
                        }
                        {
                            adjuntosRenovar.length > 0
                            ?                 
                                <MiDataTableGesUplmRenovar
                                    id={'renovartable'} 
                                    adjuntos={ adjuntosRenovar }
                                    saveAdjuntos= { saveAdjuntosRenovar }                    
                                    readonly={""}
                                    estadoForm={""}
                                    traduction={confPantalla.config.trad.components}
                                    optionSelect={ optionSelect }
                                    datatable={ confPantalla.gesdoc.controles.gesuplm.datatablepending }
                                    rowData={rowData}
                                    saveRowData={saveRowData}
                                />
                            :
                                null
                        }
                        {
                            adjuntosRenovar.length > 0
                            ?                        
                                <Button 
                                    clases={ "btn-block mb-4" }
                                    color={ "success" }  
                                    type="button" 
                                    icono={ "" }   
                                    id=""     
                                    texto={confPantalla.config.trad.components.gesuplm.btnrenovar.title}   
                                    accion={ () => renovarAction() } 
                                    disabled={ loading ? true : false }
                                />                        
                            :
                                null
                        } 
                        <FormRow>
                        {
                            infoTipAdj.idges == "1"
                            ?
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idGes  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.gesdoc.controles.agentes.id }    
                                    name=        { confPantalla.gesdoc.controles.agentes.name }   
                                    label=       { confPantalla.gesdoc.controles.agentes.label }    
                                    placeholder= { confPantalla.gesdoc.controles.agentes.placeholder }
                                    col=         { confPantalla.gesdoc.controles.agentes.col } 
                                    isClearable= { confPantalla.gesdoc.controles.agentes.isclearable }
                                    isSearchable={ confPantalla.gesdoc.controles.agentes.issearchable }
                                    dataType=    { confPantalla.gesdoc.controles.agentes.datatype }
                                    data=        { confPantalla.gesdoc.controles.agentes.data }
                                    required=    { confPantalla.gesdoc.controles.agentes.required } 
                                    disabled=    { confPantalla.gesdoc.controles.agentes.disabled }
                                    // readOnly =   { confPantalla.gesdoc.controles.agentes.readonly }
                                    readOnly =   { adjuntos.length > 0 || adjuntosRenovar.length > 0 ? "readonly" : "" }
                                    adjuntos
                                    disablethisid={confPantalla.gesdoc.controles.agentes.disablethisid}
                                    formulario=  {{id:0}}
                                    change=      { handleSelectGes }                                                    
                                />
                            :
                            infoTipAdj.idges == "2"
                            ?
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idGes  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.gesdoc.controles.articulos.id }    
                                    name=        { confPantalla.gesdoc.controles.articulos.name }   
                                    label=       { confPantalla.gesdoc.controles.articulos.label }    
                                    placeholder= { confPantalla.gesdoc.controles.articulos.placeholder }
                                    col=         { confPantalla.gesdoc.controles.articulos.col } 
                                    isClearable= { confPantalla.gesdoc.controles.articulos.isclearable }
                                    isSearchable={ confPantalla.gesdoc.controles.articulos.issearchable }
                                    dataType=    { confPantalla.gesdoc.controles.articulos.datatype }
                                    data=        { confPantalla.gesdoc.controles.articulos.data }
                                    required=    { confPantalla.gesdoc.controles.articulos.required } 
                                    disabled=    { confPantalla.gesdoc.controles.articulos.disabled }
                                    // readOnly =   { confPantalla.gesdoc.controles.articulos.readonly }
                                    readOnly =   { adjuntos.length > 0 || adjuntosRenovar.length > 0  ? "readonly" : "" }
                                    disablethisid={confPantalla.gesdoc.controles.articulos.disablethisid}
                                    formulario=  {{id:0}}
                                    change=      { handleSelectGes }                                                    
                                />
                            :
                            infoTipAdj.idges == "3"
                            ?
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idGes  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.gesdoc.controles.centros.id }    
                                    name=        { confPantalla.gesdoc.controles.centros.name }   
                                    label=       { confPantalla.gesdoc.controles.centros.label }    
                                    placeholder= { confPantalla.gesdoc.controles.centros.placeholder }
                                    col=         { confPantalla.gesdoc.controles.centros.col } 
                                    isClearable= { confPantalla.gesdoc.controles.centros.isclearable }
                                    isSearchable={ confPantalla.gesdoc.controles.centros.issearchable }
                                    dataType=    { confPantalla.gesdoc.controles.centros.datatype }
                                    data=        { confPantalla.gesdoc.controles.centros.data }
                                    required=    { confPantalla.gesdoc.controles.centros.required } 
                                    disabled=    { confPantalla.gesdoc.controles.centros.disabled }
                                    // readOnly =   { confPantalla.gesdoc.controles.centros.readonly }
                                    readOnly =   { adjuntos.length > 0 || adjuntosRenovar.length > 0  ? "readonly" : "" }
                                    disablethisid={confPantalla.gesdoc.controles.centros.disablethisid}
                                    formulario=  {{id:0}}                            
                                    change=      { handleSelectGes }                                                    
                                />
                            :
                            infoTipAdj.idges == "4"
                            ?
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idGes  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.gesdoc.controles.operaciones.id }    
                                    name=        { confPantalla.gesdoc.controles.operaciones.name }   
                                    label=       { confPantalla.gesdoc.controles.operaciones.label }    
                                    placeholder= { confPantalla.gesdoc.controles.operaciones.placeholder }
                                    col=         { confPantalla.gesdoc.controles.operaciones.col } 
                                    isClearable= { confPantalla.gesdoc.controles.operaciones.isclearable }
                                    isSearchable={ confPantalla.gesdoc.controles.operaciones.issearchable }
                                    dataType=    { confPantalla.gesdoc.controles.operaciones.datatype }
                                    data=        { confPantalla.gesdoc.controles.operaciones.data }
                                    required=    { confPantalla.gesdoc.controles.operaciones.required } 
                                    disabled=    { confPantalla.gesdoc.controles.operaciones.disabled }
                                    // readOnly =   { confPantalla.gesdoc.controles.operaciones.readonly }
                                    readOnly =   { adjuntos.length > 0 || adjuntosRenovar.length > 0  ? "readonly" : "" }
                                    disablethisid={confPantalla.gesdoc.controles.operaciones.disablethisid}                            
                                    formulario=  {{id:0}}
                                    change=      { handleSelectGes }                                                    
                                />
                            :
                            infoTipAdj.idges == "5"
                            ?
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idGes  }   
                                    loading=     { loading ? true : false }
                                    id=          { confPantalla.gesdoc.controles.equipos.id }    
                                    name=        { confPantalla.gesdoc.controles.equipos.name }   
                                    label=       { confPantalla.gesdoc.controles.equipos.label }    
                                    placeholder= { confPantalla.gesdoc.controles.equipos.placeholder }
                                    col=         { confPantalla.gesdoc.controles.equipos.col } 
                                    isClearable= { confPantalla.gesdoc.controles.equipos.isclearable }
                                    isSearchable={ confPantalla.gesdoc.controles.equipos.issearchable }
                                    dataType=    { confPantalla.gesdoc.controles.equipos.datatype }
                                    data=        { confPantalla.gesdoc.controles.equipos.data }
                                    required=    { confPantalla.gesdoc.controles.equipos.required } 
                                    disabled=    { confPantalla.gesdoc.controles.equipos.disabled }
                                    // readOnly =   { confPantalla.gesdoc.controles.equipos.readonly }
                                    readOnly =   { adjuntos.length > 0 || adjuntosRenovar.length > 0  ? "readonly" : "" }
                                    disablethisid={confPantalla.gesdoc.controles.equipos.disablethisid}                            
                                    formulario=  {{id:0}}
                                    change=      { handleSelectGes }                                                    
                                />
                            : 
                                null
                        }
                        {
                            infoTipAdj.idges > 0
                            ?
                                <Fragment>
                                    <div className={'col-3 col-xs-12'}>
                                        <button 
                                            type="button" 
                                            className="btn btn-flat btn-success fileinput-button adj btn-block " 
                                            id="fileinput-buttonadj" 
                                            disabled={idGes === 0 || loading ? true : false}
                                        >
                                            <i className="far fa-paperclip mr-1" style={{transform : "rotate(-45deg)"}}></i>
                                            {confPantalla.config.trad.components.gesuplm.btnadd.title}
                                            <input 
                                                className="btn btn-success fileinput-button" 
                                                id={"inputFiles"} 
                                                type={ idGes === 0 || loading ? "hidden" : "file"}  
                                                name={"inputFiles[]"} 
                                                multiple="multiple" 
                                                onChange={ idGes === 0 || loading ? null : (e) => handleFiles(e.target.files) } 
                                                // disabled={idGes === 0 || loading ? true : false}
                                            />
                                        </button>
                                    </div>
                                    <div className={'col-3 col-xs-12'}>
                                        <button 
                                            type="button" 
                                            className="btn btn-flat btn-success btn-block" 
                                            disabled={idGes === 0 || loading ? true : false}
                                            onClick={ (e) => addUrl(e) }>
                                                <i className="fal fa-link mr-1" onClick={ (e) => addUrl(e) }></i>
                                                {confPantalla.config.trad.components.gesuplm.btnaddurl.title}
                                        </button>
                                    </div>
                                </Fragment>
                            :
                                null
                        }
                        </FormRow>
                        {   loading ? 
                                <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        }
                        <MiDataTableGesUplm
                            id={confPantalla.gesdoc.controles.gesuplm.id}
                            columnas={confPantalla.gesdoc.controles.gesuplm.datatable.columns}
                            adjuntosExistentes={ adjuntosExistentes }
                            saveAdjuntosExistentes={ saveAdjuntosExistentes }
                            readonly={ "" }
                            optionSelect={optionSelect}
                            estadoForm= { "" }
                            columnactions={confPantalla.gesdoc.controles.gesuplm.datatable.columnactions.title}
                            traduction={confPantalla.config.trad.components}
                            buttons={ confPantalla.gesdoc.controles.gesuplm.datatable.buttons}
                            ordering={ confPantalla.gesdoc.controles.gesuplm.datatable.ordering}
                            order={ confPantalla.gesdoc.controles.gesuplm.datatable.order}
                            searching={ confPantalla.gesdoc.controles.gesuplm.datatable.searching}
                            paging={ confPantalla.gesdoc.controles.gesuplm.datatable.paging}
                            select={ confPantalla.gesdoc.controles.gesuplm.datatable.select}
                            grouping={ confPantalla.gesdoc.controles.gesuplm.datatable.grouping}
                            pagelength={ confPantalla.gesdoc.controles.gesuplm.datatable.pagelength }
                            adjuntosplegados={confPantalla.gesdoc.controles.gesuplm.datatable.adjuntosplegados}
                            // onlyAdminsEditAdj={onlyAdminsEditAdj}
                            reloadTable={init}
                            renovar={renovar}
                            verHistoria={verHistoria}
                            saveShowModalHistoria={saveShowModalHistoria}
                            renovarUrl={renovarUrl}
                        />               
                    </Section>
            }            
            <Modal
                show={showModalHistoria}
                onHide={ () => saveShowModalHistoria(false)}                            
                aria-labelledby="example-custom-modal-styling-title"
                centered={true}                    
                dialogClassName="modal-90w"                                             
            > 
                <Modal.Header closeButton>
                    <h4>{confPantalla.gesdoc.controles.modalhistoria.header.title}</h4>
                </Modal.Header>                         
                <Modal.Body>
                    <MiDataTableGesUplm
                        id={"tablaHistoriaAdjs"}
                        columnas={confPantalla.gesdoc.controles.modalhistoria.datatable.columns}
                        adjuntosExistentes={ datosHistoria }
                        saveAdjuntosExistentes={ null }
                        readonly={ "" }
                        optionSelect={optionSelect}
                        estadoForm= { "" }
                        columnactions={confPantalla.gesdoc.controles.modalhistoria.datatable.columnactions.title}
                        traduction={confPantalla.config.trad.components}
                        buttons={ confPantalla.gesdoc.controles.modalhistoria.datatable.buttons}
                        ordering={ confPantalla.gesdoc.controles.modalhistoria.datatable.ordering}
                        order={ confPantalla.gesdoc.controles.modalhistoria.datatable.order}
                        searching={ confPantalla.gesdoc.controles.modalhistoria.datatable.searching}
                        paging={ confPantalla.gesdoc.controles.modalhistoria.datatable.paging}
                        select={ confPantalla.gesdoc.controles.modalhistoria.datatable.select}
                        grouping={ confPantalla.gesdoc.controles.modalhistoria.datatable.grouping}
                        pagelength={ confPantalla.gesdoc.controles.modalhistoria.datatable.pagelength }
                        adjuntosplegados={confPantalla.gesdoc.controles.modalhistoria.datatable.adjuntosplegados}
                        // onlyAdminsEditAdj={onlyAdminsEditAdj}
                        reloadTable={init}
                        renovar={renovar}
                        verHistoria={verHistoria}
                        saveShowModalHistoria={saveShowModalHistoria}
                        renovarUrl={renovarUrl}                        
                    /> 
                    
                </Modal.Body>
                <Modal.Footer>
                    <div className='text-right'>                                              
                        <button 
                                className="btn btn-danger mt-1"
                                onClick={ () => saveShowModalHistoria(false) }                                        
                        >
                            {confPantalla.gesdoc.controles.modalhistoria.btncancelar.title}
                        </button>                                            
                    </div>
                </Modal.Footer>                            
            </Modal> 

            {/* MODAL URL */}
            <Modal
                size="lg"
                show={showModalUrl}
                onHide={ () => saveShowModalUrl(false)}                            
                aria-labelledby="example-custom-modal-styling-title"
                centered={true}
                contentClassName="likeSw"
                backdropClassName="backLikeSw"                                              
                >                          
                <Modal.Body>
                    <div className='form-group'>
                        <FormInput                                                        
                            estadoForm= { "" }
                            value=      { url }
                            loading=    { false }
                            id=         { "" }    
                            type=       { "text" }  
                            name=       { "" }   
                            label=      { "" }                                                       
                            placeholder={ confPantalla.config.trad.components.gesuplm.urlhelp.title }    
                            col=        { "12" } 
                            required=   { false }
                            readonly=   { false }                                                
                            disabled=   { false }
                            change=     { handleUrl }
                            onBlur=     {null}
                            clasesInput={urlVacia || urlVacia == "existe" ? "is-invalid" : null} 
                        />
                        {
                            urlVacia == "existe"
                            ?
                                <small id="emailHelp" class="form-text text-danger">{confPantalla.config.trad.components.gesuplm.duplicateurl.title}</small>
                            :
                            urlVacia == "invalida"
                            ?
                                <small id="emailHelp" class="form-text text-danger">{confPantalla.config.trad.components.gesuplm.urlinvalida.title}</small>
                            :
                                null
                        }
                    </div>
                    <button type="button" className="btn btn-flat btn-success btn-block " onClick={ (e) => addUrlAction(e) }>
                        <i className="fal fa-plus mr-1" /*onClick={ (e) => addUrlAction(e) }*/></i>
                    </button>
                </Modal.Body>                            
            </Modal>    
                          
        </Fragment>
    )

}

export default GesUplm;